var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 0C12.4183 0 16 3.58173 16 7.99999C16 12.0902 12.9303 15.463 8.96921 15.9414V10.4447L11.1334 10.4447L11.5823 8H8.96921V7.13539C8.96921 6.48945 9.09591 6.04226 9.38657 5.75656C9.67726 5.47084 10.1319 5.34662 10.7878 5.34662C10.9538 5.34662 11.1066 5.34827 11.2422 5.35157C11.4394 5.35638 11.6001 5.36467 11.712 5.37644V3.16032C11.6673 3.14789 11.6145 3.13547 11.5554 3.12324C11.4214 3.09554 11.2548 3.06883 11.0757 3.04537C10.7016 2.99635 10.2729 2.96153 9.97292 2.96153C8.7616 2.96153 7.84614 3.22068 7.20713 3.75746C6.43592 4.40527 6.06739 5.45748 6.06739 6.94659V7.99999H4.41772V10.4447H6.06739V15.7644C2.58288 14.8999 0 11.7518 0 7.99999C0 3.58173 3.58173 0 7.99999 0Z",
    fill: "#0F0F0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookBlack);
export default __webpack_public_path__ + "static/media/facebook_black.bb804a04ad90d08544caf48d176ee985.svg";
export { ForwardRef as ReactComponent };